import { useContext } from 'react';
import { Navigate } from 'react-router-dom';
import { MyContext } from '../context';

const RoleRoute = ({ roles, children }) => {
	const { userProfile, activeStoreRole } = useContext(MyContext);
	// Role is per-store now (user_store_access.role) except for PLATFORMADMIN,
	// which stays global -- effectiveRole reflects whichever store is active.
	const effectiveRole = userProfile?.role === 'PLATFORMADMIN' ? 'PLATFORMADMIN' : activeStoreRole;

	if (!roles.includes(effectiveRole)) {
		return <Navigate to='/' replace />;
	}

	return children;
};

export default RoleRoute;
